import React from "react";
import { Input } from "@/components/ui/input";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";

const sanitizeOtp = (value, maxLength = 6) => String(value || "").replace(/\D/g, "").slice(0, maxLength);

class OtpCodeFieldErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("OtpCodeField fallback activated:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export const OtpCodeField = ({
  value,
  onChange,
  maxLength = 6,
  testId,
  fallbackTestId,
  ariaLabel = "OTP code input",
}) => {
  const handleChange = (nextValue) => {
    onChange(sanitizeOtp(nextValue, maxLength));
  };

  const safeFallbackTestId = fallbackTestId || `${testId}-fallback`;

  return (
    <OtpCodeFieldErrorBoundary
      fallback={(
        <Input
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={maxLength}
          placeholder="123456"
          aria-label={`${ariaLabel} fallback`}
          className="h-12 text-center text-lg tracking-[0.5em]"
          data-testid={safeFallbackTestId}
        />
      )}
    >
      <InputOTP
        maxLength={maxLength}
        value={value}
        onChange={handleChange}
        pasteTransformer={(pastedText) => sanitizeOtp(pastedText, maxLength)}
        aria-label={ariaLabel}
        data-testid={testId}
      >
        <InputOTPGroup>
          {Array.from({ length: maxLength }, (_, index) => (
            <InputOTPSlot key={index} index={index} />
          ))}
        </InputOTPGroup>
      </InputOTP>
    </OtpCodeFieldErrorBoundary>
  );
};